













































import { SalesOrgImportDto } from '@/services/connecteur'
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import SalesOrgImportItem from './SalesOrgImportItem.vue'

@Component({
  components: {
    SalesOrgImportItem
  }
})
export default class SalesOrgImportCard extends Vue {
  @Prop({ required: true })
  public importStatus!: SalesOrgImportDto[]
}
